/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByLowerTitle } from './Scaffolding';
import {
    Datagrid,
    TextField,
    Show,
    Create,
    SimpleForm,
    Edit,
    SimpleShowLayout,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { TextInput } from '../lib/wrappers/Inputs';
import { Typography, Box } from '@mui/material';
var titleStyle = { color: "#AE223F" }
export const AssessmentLabels = {
    pageTitle: 'Assessments',
    compensatedPassInformation: 'Comp Pass Information',
    duration: 'Duration (in Min)',
    KIScategory: 'KIS Category',
};

export const AssessmentList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList {...props} filters={<BaseFilter />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="title" />
                    <TextField source="category" />
                    <TextField source="assessmentType" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const AssessmentCreate = (props) => (
    <Create {...props} redirect="edit">
        <AssessmentInputForm {...props} />
    </Create>
);

export const AssessmentEdit = (props) => (
    <Edit title={<ShowTitleByLowerTitle />} {...props} redirect="edit">
        <AssessmentInputForm {...props} />
    </Edit>
);


const AssessmentInputForm = (source) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SimpleForm {...source} toolbar={<EditToolbar />}>
            <Box display="flex" width={1}>  {/* sx={{ height: '40px', borderBottom: '1px solid #AE223F', marginBottom: '15px' }}> */}
                        <Box flex={1}>
                            <Typography variant="h6" style={titleStyle} >
                                <TextField source="id" label={false} />
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={3}>
                            <TextInput source="title" fullWidth/>
                        </Box>
                        <Box flex={3} ml="0.5em">
                            <TextInput source="category" fullWidth/>
                        </Box>
                        <Box flex={1} ml="0.5em">
                            <TextInput source="assessmentType" fullWidth />
                        </Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <TextInput source="created_at" disabled />
                            <TextInput source="updated_at" disabled sx={{ marginLeft: '0.5em' }} />
                        </Box>
                    </Box>
            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};
